import { useEffect, useRef } from 'react';
import clock from '~/assets/icons/clock.svg';
import { ImgIcon } from '~/components/ui/ImgIcon';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { formatTime } from '~/shared';
import { StyledContainer } from './UpdatePriceTimer.styled';

const UpdatePriceTimer = ({
	...props
}: React.HTMLAttributes<HTMLDivElement>) => {
	const updatePriceTimestamp = useObservable(
		rage.lootBuyers.getUpdatePriceTimestamp(),
	);
	const timeRef = useRef<HTMLDivElement>(null);

	const calculateTimeLeft = (timestamp: number): number => {
		const now = Date.now();
		const timeLeft = Math.max(0, Math.floor((timestamp - now) / 1000));
		return timeLeft;
	};

	useEffect(() => {
		if (!updatePriceTimestamp) {
			if (timeRef.current) {
				timeRef.current.textContent = formatTime(0, '{hh}:{mm}:{ss}');
			}
			return;
		}

		const update = () => {
			const timeLeft = calculateTimeLeft(updatePriceTimestamp);

			if (timeRef.current) {
				timeRef.current.textContent = formatTime(
					timeLeft * 1000,
					'{hh}:{mm}:{ss}',
				);
			}
		};

		update();

		const timer = setInterval(update, 1000);

		return () => clearInterval(timer);
	}, [updatePriceTimestamp]);

	return (
		<StyledContainer {...props}>
			<Text>Обновление цен, через:</Text>
			<Text ref={timeRef} style={{ fontWeight: 500 }} />
			<ImgIcon icon={clock} width={16} height={16} color="#000000" />
		</StyledContainer>
	);
};

export { UpdatePriceTimer };
